import React, { useState, useEffect } from 'react';
import './styles/App.css';
import PhotoGallery from './components/PhotoGallery';
import Footer from './components/Footer';
import Lightbox from './components/Lightbox';
import { loadPhotos } from './utils/photoUtils';

function App() {
  const [photos, setPhotos] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  useEffect(() => {
    const fetchPhotos = async () => {
      const photoList = await loadPhotos();
      setPhotos(photoList);
    };
    fetchPhotos();
  }, []);

  const openLightbox = (photo) => {
    setSelectedPhoto(photo);
  };

  const closeLightbox = () => {
    setSelectedPhoto(null);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && selectedPhoto) {
        closeLightbox();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [selectedPhoto]);

  return (
    <div className="App">
      <header className="app-header">
        <h1 className="app-title">Shao's Sky</h1>
        <p className="app-subtitle">天文摄影作品展示</p>
      </header>

      <main className="app-main">
        <PhotoGallery photos={photos} onPhotoClick={openLightbox} />
      </main>

      <Footer />

      {selectedPhoto && (
        <Lightbox photo={selectedPhoto} onClose={closeLightbox} />
      )}
    </div>
  );
}

export default App;